export const SET_GLA_RESULT_AVAILABLE = 'SET_GLA_RESULT_AVAILABLE';

export const setGLAResultAvailable = (isAvailable) => ({
  type: SET_GLA_RESULT_AVAILABLE,
  payload: isAvailable,
});
